import { Http, Headers, Response, RequestOptions } from "@angular/http";
import { Injectable } from "@angular/core";
import { HttpModule } from '@angular/http';
import 'rxjs/Rx';
import { AppSettings } from '../services/app-settings';


@Injectable()


export class ConfigApp {

    public UserId: any = '';
    public PushId: any = '';
    constructor() { };

    SetUserPush(push_id: any) {
        this.PushId = push_id;
    }

};




// WEBPACK FOOTER //
// ./src/providers/config.app.ts